import { CallState } from '../../features/call/call.types';
import { useCallState } from '../useCallState';

export const phoneCallStates = [
  CallState.PhoneCallInitializing,
  CallState.PhoneCallRinging,
  CallState.PhoneCallInProgress,
  CallState.PhoneCallLeavingAfterError,
  CallState.PhoneCallLeaving,
];

export const useIsPhoneCall = (): boolean => {
  const { callState } = useCallState();
  return phoneCallStates.includes(callState);
};
